module.exports = __webpack_public_path__ + "static/img/15areaB_3.2603311.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/15areaB_3.png
// module id = 1125
// module chunks = 1